import { filterProps } from '@roc/ui/utils';
import { GridColumnProps } from '@roc/ui';

export const DEFAULT_SORT_MODEL = [{ colId: 'businessTimeWaiting', sort: 'desc' }];

export const titleCommunicationColumns: GridColumnProps[] = [
  {
    field: 'loanId',
    headerName: 'Loan ID',
    cellRenderer: 'loanIdCellRenderer',
    width: 110,
    ...filterProps(),
  },
  {
    field: 'loanType',
    headerName: 'Loan Type',
    minWidth: 130,
    ...filterProps(),
  },
  {
    field: 'loanStatus',
    headerName: 'Loan Status',
    minWidth: 130,
    ...filterProps(),
  },
  {
    field: 'submissionDate',
    headerName: 'Submission Date',
    minWidth: 150,
    ...filterProps(),
  },
  {
    field: 'chatRoomName',
    headerName: 'Chat Room',
    minWidth: 180,
    ...filterProps(),
  },
  {
    field: 'internalMessageFrom',
    headerName: 'Last Message From',
    minWidth: 180,
    ...filterProps(),
  },
  {
    field: 'businessTimeWaiting',
    headerName: 'Business Time Waiting',
    minWidth: 220,
    ...filterProps(),
  },
  {
    field: 'lastMessageTime',
    headerName: 'Last Message Time',
    minWidth: 200,
    ...filterProps(),
  },
  {
    field: 'lastMessageSentiment',
    headerName: 'Sentiment',
    minWidth: 130,
    ...filterProps(),
  },
  {
    field: 'primaryCsc',
    headerName: 'Primary CSC',
    minWidth: 160,
    ...filterProps(),
  },
  {
    field: 'underwriter',
    headerName: 'Underwriter',
    minWidth: 160,
    ...filterProps(),
  },
  {
    field: 'actions',
    headerName: 'Actions',
    cellRenderer: 'titleCommunicationActionsCellRenderer',
    maxWidth: 100,
    sortable: false,
    filter: false,
    pinned: 'right',
    lockPinned: true,
  },
];
